"use strict";

var _interopRequireWildcard = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _slicedToArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/slicedToArray.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _vuePdfNoSss = _interopRequireDefault(require("vue-pdf/src/vuePdfNoSss.vue"));
var _mammoth = _interopRequireDefault(require("mammoth"));
var XLSX = _interopRequireWildcard(require("xlsx"));
var _axios = _interopRequireDefault(require("axios"));
var _auth = require("@utils/auth");
var _cloud = require("@utils/cloud");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'FilePreviewer',
  components: {
    pdf: _vuePdfNoSss.default // 注册 pdf 组件
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    appName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      wordContents: [],
      excelDatas: [],
      excelHeaders: [],
      showPrev: false,
      showNext: false,
      currentImageIndex: 0,
      // 新增响应式数据，用于存储大图预览的当前索引
      currentImagePreviewIndex: 0,
      wordPages: [],
      currentWordPage: [],
      pageNumbers: [],
      numPages: [],
      showPdfPrev: [],
      showPdfNext: [],
      // 新增文本内容数组
      textContents: [],
      pdfUrls: []
    };
  },
  computed: {
    // 筛选图片文件
    imageFiles: function imageFiles() {
      return this.fileList.filter(function (file) {
        return /\.(jpg|jpeg|png|gif|bmp)$/i.test(file.fileUrl);
      });
    },
    // 筛选 PDF 文件
    pdfFiles: function pdfFiles() {
      return this.fileList.filter(function (file) {
        return /\.pdf$/i.test(file.fileUrl);
      });
    },
    // 筛选 Word 文件
    wordFiles: function wordFiles() {
      return this.fileList.filter(function (file) {
        return /\.(doc|docx)$/i.test(file.fileUrl);
      });
    },
    // 筛选 Excel 文件
    excelFiles: function excelFiles() {
      return this.fileList.filter(function (file) {
        return /\.(xls|xlsx)$/i.test(file.fileUrl);
      });
    },
    // 新增筛选文本文件
    textFiles: function textFiles() {
      return this.fileList.filter(function (file) {
        return /\.(txt|text)$/i.test(file.fileUrl);
      });
    },
    videoFiles: function videoFiles() {
      return this.fileList.filter(function (file) {
        return /\.(mp4|mov|avi|mkv|flv)$/i.test(file.fileUrl);
      });
    },
    // 新增空状态计算属性
    allFilesEmpty: function allFilesEmpty() {
      return this.imageFiles.length === 0 && this.pdfFiles.length === 0 && this.wordFiles.length === 0 && this.excelFiles.length === 0 && this.textFiles.length === 0 && this.videoFiles.length === 0;
    },
    unsupportedFiles: function unsupportedFiles() {
      var _this = this;
      return this.fileList.filter(function (file) {
        return !_this.isFileSupported(file.fileUrl);
      });
    }
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler: function handler() {
        var _this2 = this;
        return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
          var _iterator, _step, _step$value, index, pdfFile, response, blob, pdfUrl, _iterator2, _step2, _step2$value, _index, wordFile, _response, _blob, arrayBuffer, result, _iterator3, _step3, _step3$value, _index2, excelFile, _response2, _arrayBuffer, workbook, firstSheetName, worksheet, data, headers, rows, _iterator4, _step4, _step4$value, _index3, textFile, _response3, text, _t, _t2, _t3, _t4, _t5, _t6, _t7, _t8;
          return (0, _regenerator2.default)().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _this2.wordContents = [];
                _this2.excelDatas = [];
                _this2.excelHeaders = [];
                _this2.currentImageIndex = 0;
                _this2.textContents = [];
                _this2.currentImageIndex = 0;
                _this2.pdfUrls = [];
                _this2.pageNumbers = new Array(_this2.pdfFiles.length).fill(1);
                _this2.numPages = new Array(_this2.pdfFiles.length).fill(0);

                // 加载 PDF 文件内容
                _iterator = (0, _createForOfIteratorHelper2.default)(_this2.pdfFiles.entries());
                _context.p = 1;
                _iterator.s();
              case 2:
                if ((_step = _iterator.n()).done) {
                  _context.n = 7;
                  break;
                }
                _step$value = (0, _slicedToArray2.default)(_step.value, 2), index = _step$value[0], pdfFile = _step$value[1];
                _context.p = 3;
                _context.n = 4;
                return (0, _axios.default)({
                  method: 'get',
                  url: process.env.VUE_APP_BASE_API + _cloud.urls.projectName + '/sop/file/download',
                  params: {
                    fileId: pdfFile.docFileId
                  },
                  headers: {
                    Authorization: 'Bearer ' + (0, _auth.getToken)()
                  },
                  responseType: 'blob'
                });
              case 4:
                response = _context.v;
                blob = new Blob([response.data], {
                  type: 'application/pdf'
                });
                pdfUrl = window.URL.createObjectURL(blob);
                _this2.pdfUrls.push(pdfUrl);
                _context.n = 6;
                break;
              case 5:
                _context.p = 5;
                _t = _context.v;
                console.error('Failed to load PDF file:', _t);
                _this2.pdfUrls.push('');
              case 6:
                _context.n = 2;
                break;
              case 7:
                _context.n = 9;
                break;
              case 8:
                _context.p = 8;
                _t2 = _context.v;
                _iterator.e(_t2);
              case 9:
                _context.p = 9;
                _iterator.f();
                return _context.f(9);
              case 10:
                // 加载 Word 文件内容
                _iterator2 = (0, _createForOfIteratorHelper2.default)(_this2.wordFiles.entries());
                _context.p = 11;
                _iterator2.s();
              case 12:
                if ((_step2 = _iterator2.n()).done) {
                  _context.n = 19;
                  break;
                }
                _step2$value = (0, _slicedToArray2.default)(_step2.value, 2), _index = _step2$value[0], wordFile = _step2$value[1];
                _context.p = 13;
                _context.n = 14;
                return (0, _axios.default)({
                  method: 'get',
                  url: process.env.VUE_APP_BASE_API + _cloud.urls.projectName + '/sop/file/download',
                  params: {
                    fileId: wordFile.docFileId
                  },
                  headers: {
                    Authorization: 'Bearer ' + (0, _auth.getToken)()
                  },
                  responseType: 'blob'
                });
              case 14:
                _response = _context.v;
                // 直接使用 response.data，因为它已经是 Blob 对象
                _blob = _response.data;
                _context.n = 15;
                return _blob.arrayBuffer();
              case 15:
                arrayBuffer = _context.v;
                _context.n = 16;
                return _mammoth.default.convertToHtml({
                  arrayBuffer: arrayBuffer
                }, {
                  convertImage: _mammoth.default.images.imgElement(function (image) {
                    return image.read("base64").then(function (base64) {
                      return {
                        src: "data:" + image.contentType + ";base64," + base64
                      };
                    });
                  })
                });
              case 16:
                result = _context.v;
                _this2.wordContents.push(result.value);
                _context.n = 18;
                break;
              case 17:
                _context.p = 17;
                _t3 = _context.v;
                console.error('Failed to load Word file:', _t3);
                _this2.wordContents.push('Word 文件加载失败');
                _this2.wordPages[_index] = [];
                _this2.currentWordPage[_index] = 0;
              case 18:
                _context.n = 12;
                break;
              case 19:
                _context.n = 21;
                break;
              case 20:
                _context.p = 20;
                _t4 = _context.v;
                _iterator2.e(_t4);
              case 21:
                _context.p = 21;
                _iterator2.f();
                return _context.f(21);
              case 22:
                // 加载 Excel 文件内容
                _iterator3 = (0, _createForOfIteratorHelper2.default)(_this2.excelFiles.entries());
                _context.p = 23;
                _iterator3.s();
              case 24:
                if ((_step3 = _iterator3.n()).done) {
                  _context.n = 30;
                  break;
                }
                _step3$value = (0, _slicedToArray2.default)(_step3.value, 2), _index2 = _step3$value[0], excelFile = _step3$value[1];
                _context.p = 25;
                _context.n = 26;
                return (0, _axios.default)({
                  method: 'get',
                  url: process.env.VUE_APP_BASE_API + _cloud.urls.projectName + '/sop/file/download',
                  params: {
                    fileId: excelFile.docFileId
                  },
                  headers: {
                    Authorization: 'Bearer ' + (0, _auth.getToken)()
                  },
                  responseType: 'blob'
                });
              case 26:
                _response2 = _context.v;
                _context.n = 27;
                return _response2.data.arrayBuffer();
              case 27:
                _arrayBuffer = _context.v;
                workbook = XLSX.read(_arrayBuffer, {
                  type: 'array'
                });
                firstSheetName = workbook.SheetNames[0];
                worksheet = workbook.Sheets[firstSheetName];
                data = XLSX.utils.sheet_to_json(worksheet, {
                  header: 1
                });
                headers = data[0];
                rows = data.slice(1).map(function (row) {
                  return row.reduce(function (obj, value, index) {
                    obj[index.toString()] = value;
                    return obj;
                  }, {});
                });
                _this2.excelHeaders.push(headers);
                _this2.excelDatas.push(rows);
                _context.n = 29;
                break;
              case 28:
                _context.p = 28;
                _t5 = _context.v;
                console.error('Failed to load Excel file:', _t5);
                _this2.excelHeaders.push([]);
                _this2.excelDatas.push([]);
              case 29:
                _context.n = 24;
                break;
              case 30:
                _context.n = 32;
                break;
              case 31:
                _context.p = 31;
                _t6 = _context.v;
                _iterator3.e(_t6);
              case 32:
                _context.p = 32;
                _iterator3.f();
                return _context.f(32);
              case 33:
                // 新增加载文本文件内容
                _iterator4 = (0, _createForOfIteratorHelper2.default)(_this2.textFiles.entries());
                _context.p = 34;
                _iterator4.s();
              case 35:
                if ((_step4 = _iterator4.n()).done) {
                  _context.n = 41;
                  break;
                }
                _step4$value = (0, _slicedToArray2.default)(_step4.value, 2), _index3 = _step4$value[0], textFile = _step4$value[1];
                _context.p = 36;
                _context.n = 37;
                return (0, _axios.default)({
                  method: 'get',
                  url: process.env.VUE_APP_BASE_API + _cloud.urls.projectName + '/sop/file/download',
                  params: {
                    fileId: textFile.docFileId
                  },
                  headers: {
                    Authorization: 'Bearer ' + (0, _auth.getToken)()
                  },
                  responseType: 'blob'
                });
              case 37:
                _response3 = _context.v;
                _context.n = 38;
                return _response3.data.text();
              case 38:
                text = _context.v;
                // 替换换行符为 HTML 换行标签
                _this2.textContents.push(text.replace(/\n/g, '<br>'));
                _context.n = 40;
                break;
              case 39:
                _context.p = 39;
                _t7 = _context.v;
                console.error('Failed to load text file:', _t7);
                _this2.textContents.push('文本文件加载失败');
              case 40:
                _context.n = 35;
                break;
              case 41:
                _context.n = 43;
                break;
              case 42:
                _context.p = 42;
                _t8 = _context.v;
                _iterator4.e(_t8);
              case 43:
                _context.p = 43;
                _iterator4.f();
                return _context.f(43);
              case 44:
                return _context.a(2);
            }
          }, _callee, null, [[36, 39], [34, 42, 43, 44], [25, 28], [23, 31, 32, 33], [13, 17], [11, 20, 21, 22], [3, 5], [1, 8, 9, 10]]);
        }))();
      }
    }
  },
  methods: {
    // 确保正确更新对应 PDF 文件的总页数
    onNumPages: function onNumPages(index, numPages) {
      this.$set(this.numPages, index, numPages);
    },
    // 确保正确更新对应 PDF 文件的当前页码
    previousPage: function previousPage(index) {
      if (this.pageNumbers[index] > 1) {
        this.$set(this.pageNumbers, index, this.pageNumbers[index] - 1);
      }
    },
    // 确保正确更新对应 PDF 文件的当前页码
    nextPage: function nextPage(index) {
      if (this.pageNumbers[index] < this.numPages[index]) {
        this.$set(this.pageNumbers, index, this.pageNumbers[index] + 1);
      }
    },
    handleMouseMove: function handleMouseMove(event) {
      var imageWrapper = this.$el.querySelector('.image-wrapper');
      if (imageWrapper) {
        var rect = imageWrapper.getBoundingClientRect();
        var x = event.clientX - rect.left;
        var width = rect.width;
        this.showPrev = x < width * 0.3;
        this.showNext = x > width * 0.7;
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      this.showPrev = false;
      this.showNext = false;
    },
    prevImage: function prevImage() {
      this.currentImageIndex = (this.currentImageIndex - 1 + this.imageFiles.length) % this.imageFiles.length;
      this.updateImagePreviewIndex();
    },
    nextImage: function nextImage() {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.imageFiles.length;
      this.updateImagePreviewIndex();
    },
    // 新增方法，用于更新大图预览的当前索引
    updateImagePreviewIndex: function updateImagePreviewIndex() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.currentImagePreviewIndex = _this3.currentImageIndex;
      });
    },
    getProxyUrl: function getProxyUrl(url) {
      var baseUrlMatchs = url.match(/^(https?:\/\/[^/]+)/);
      if (baseUrlMatchs) {
        var baseUrl = baseUrlMatchs[1];
        return url.replace(baseUrl, this.appName);
      }
      return url;
    },
    prevWordPage: function prevWordPage(index) {
      if (this.currentWordPage[index] > 0) {
        this.currentWordPage[index]--;
        this.$forceUpdate(); // 强制刷新视图
      }
    },
    nextWordPage: function nextWordPage(index) {
      if (this.currentWordPage[index] < this.wordPages[index].length - 1) {
        this.currentWordPage[index]++;
        this.$forceUpdate(); // 强制刷新视图
      }
    },
    // 分页函数
    paginateWordContent: function paginateWordContent(htmlContent, containerHeight) {
      var pages = [];
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = 'absolute';
      tempDiv.style.visibility = 'hidden';
      tempDiv.style.width = '100%';
      tempDiv.style.boxSizing = 'border-box'; // 确保盒模型计算正确
      document.body.appendChild(tempDiv);
      var currentPageContent = '';
      var currentHeight = 0;
      var children = Array.from(tempDiv.children);
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        var originalDisplay = child.style.display;
        child.style.display = 'block'; // 确保元素以块级元素计算高度

        // 先尝试添加当前元素到当前页
        tempDiv.innerHTML = currentPageContent + child.outerHTML;
        var newHeight = tempDiv.offsetHeight;
        if (newHeight > containerHeight && currentPageContent) {
          pages.push(currentPageContent);
          currentPageContent = child.outerHTML;
        } else {
          currentPageContent += child.outerHTML;
        }
        child.style.display = originalDisplay; // 恢复元素原始显示样式
      }
      if (currentPageContent) {
        pages.push(currentPageContent);
      }
      document.body.removeChild(tempDiv);
      return pages;
    },
    getFileName: function getFileName(filePath) {
      var parts = filePath.split('/');
      return parts[parts.length - 1];
    },
    openAllFilesPreview: function openAllFilesPreview() {
      var routeData = this.$router.resolve({
        path: '/all-files-preview',
        query: {
          files: JSON.stringify(this.fileList.map(function (file) {
            return file.fileUrl;
          }))
        }
      });
      window.open(routeData.href, '_blank');
    },
    isFileSupported: function isFileSupported(fileUrl) {
      return /\.(jpg|jpeg|png|gif|bmp|pdf|doc|docx|xls|xlsx|txt|text|mp4|mov|avi|mkv|flv)$/i.test(fileUrl);
    },
    // 新增方法，获取文件扩展名
    getFileExtension: function getFileExtension(fileUrl) {
      var match = fileUrl.match(/\.([^.]+)$/i);
      return match ? match[1].toUpperCase() : '未知';
    }
  }
};